import axios from "axios"

export const searchEvents = async (search: any) => {
    const { data } = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}events/search`,
        search
    )
    return data
}
